import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Container, Navbar as BootstrapNavbar, Nav } from 'react-bootstrap';
import { ThemeContext } from '../../App';

const Navbar = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <BootstrapNavbar bg={theme === 'dark' ? 'dark' : 'light'} variant={theme} expand="lg" className="shadow-sm">
      <Container>
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <i className="bi bi-youtube me-2 text-danger"></i>
          <span className="fw-bold">TechVahini</span>
        </Link>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavLink 
              to="/" 
              className={({ isActive }) => `nav-link ${isActive ? 'active fw-bold' : ''}`}
            >
              Home
            </NavLink>
            <NavLink 
              to="/videos" 
              className={({ isActive }) => `nav-link ${isActive ? 'active fw-bold' : ''}`}
            >
              Videos
            </NavLink>
            <NavLink 
              to="/blogs" 
              className={({ isActive }) => `nav-link ${isActive ? 'active fw-bold' : ''}`}
            >
              Blogs
            </NavLink>
            <NavLink 
              to="/products" 
              className={({ isActive }) => `nav-link ${isActive ? 'active fw-bold' : ''}`}
            >
              Digital Products
            </NavLink>
            <NavLink 
              to="/contact" 
              className={({ isActive }) => `nav-link ${isActive ? 'active fw-bold' : ''}`}
            >
              Contact Us
            </NavLink>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
